import { addDays, endOfWeek, startOfWeek } from "date-fns";

export const getWeekDays = (weekStart) => {
  const days = [weekStart];
  for (let i = 1; i < 7; i += 1) {
    days.push(addDays(weekStart, 1));
  }
  return days;
};

export const getWeekRange = (date) => {
  return {
    from: startOfWeek(date),
    to: endOfWeek(date),
  };
};
